import { render, staticRenderFns } from "./IconChart.vue?vue&type=template&id=5745a4f0&"
import script from "./IconChart.vue?vue&type=script&lang=js&"
export * from "./IconChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5745a4f0')) {
      api.createRecord('5745a4f0', component.options)
    } else {
      api.reload('5745a4f0', component.options)
    }
    module.hot.accept("./IconChart.vue?vue&type=template&id=5745a4f0&", function () {
      api.rerender('5745a4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconChart.vue"
export default component.exports